export enum ContractStatuses {
	deactivated = 'deactivated',
	fixedTemporaryDeactivated = 'fixedTemporaryDeactivated',
	fixedOccasionallyDeactivated = 'fixedOccasionallyDeactivated',
	// status for i18n on FE side
	dataUpdated = 'dataUpdated',
	// status from BE
	needUpdate = 'NEED_UPDATE',
}
